import { render, staticRenderFns } from "./ModalClientWeddingForm.vue?vue&type=template&id=f3d65aec&scoped=true"
import script from "./ModalClientWeddingForm.vue?vue&type=script&lang=js"
export * from "./ModalClientWeddingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d65aec",
  null
  
)

export default component.exports